import { useColumnsApi } from '../../../../api/queries/useColumnsApi.js';
import { useRestrictionsApi } from '../../../../api/queries/usePlanningRestricitionsApi.js';
import { usePreviewActivityListApi } from '../../../../api/queries/usePreviewActivityListApi.js';
import { useChosenLevel } from '../../../../hooks/useChosenLevel.js';
import type { MpLevelNames } from '../../../../types/shared.js';
import EmptyContent from './EmptyContent.jsx';
import ErrorContent from './ErrorContent.jsx';
import { ConfirmCurrencyProvider } from './TableGrid/ConfirmCurrencyProvider/ConfirmCurrencyProvider.jsx';
import { DeleteMediaDataProvider } from './TableGrid/DeleteMediaDataProvider/DeleteMediaDataProvider.jsx';
import TableGrid from './TableGrid/TableGrid.jsx';
import TableGridSkeleton from './TableGrid/TableGridSkeleton.jsx';

type SafeLevel = {
  id: string;
  level: MpLevelNames;
};

const LevelDetails = () => {
  const {
    data: activityData,
    isPending: isActivityListPending,
    isError: isActivityListError,
  } = usePreviewActivityListApi();
  const {
    data: columnsData,
    isPending: isColumnsPending,
    isError: isColumnsError,
  } = useColumnsApi();

  const { data: restrictions } = useRestrictionsApi();

  const selectedLevelInfo = useChosenLevel();

  const isPending = isActivityListPending || isColumnsPending;
  const isError = isActivityListError || isColumnsError;

  if (isPending) {
    return <TableGridSkeleton />;
  }

  if (isError || !selectedLevelInfo.id || !columnsData?.items.length) {
    return <ErrorContent />;
  }

  if (!activityData?.items.length) {
    return <EmptyContent />;
  }

  return (
    <ConfirmCurrencyProvider>
      <DeleteMediaDataProvider>
        <div className="flex-1">
          <TableGrid
            columnsData={columnsData}
            selectedLevelInfo={selectedLevelInfo as SafeLevel}
            restrictions={restrictions}
          />
        </div>
      </DeleteMediaDataProvider>
    </ConfirmCurrencyProvider>
  );
};

export default LevelDetails;
